module.exports = __webpack_public_path__ + "static/media/users-medical.9b2c3d78.svg";